'use strict';

var _extends = require('./extends-733dd656.js');
var polished_esm = require('./polished.esm-8ddeb0a5.js');

var colorVariants = ['default', 'defaultT10', 'defaultT20', 'defaultT70', 'defaultL10', 'defaultL20', 'defaultL40', 'dark', 'light'];
var lightenAlpha = {
  10: 0.1,
  20: 0.2,
  40: 0.4,
  70: 0.7
};
var transparencyAlpha = {
  10: 0.9,
  20: 0.8,
  40: 0.6,
  70: 0.3
};
function lighten(color, transparency) {
  return polished_esm.curriedMix(transparency, color, '#FFFFFF').toUpperCase();
}
function colorBuilder(base, baseDarkLightVariations) {
  var variations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    includeDefaultShades: false,
    includeLightShades: false,
    includeDefaultTransparency: false
  };
  var dark = baseDarkLightVariations.dark,
      light = baseDarkLightVariations.light;
  return _extends._extends_1({
    "default": base
  }, light && {
    light: light
  }, dark && {
    dark: dark
  }, variations.includeDefaultShades && {
    defaultL40: lighten(base, lightenAlpha[40]),
    defaultL20: lighten(base, lightenAlpha[20]),
    defaultL10: lighten(base, lightenAlpha[10])
  }, variations.includeLightShades && {
    defaultL40: lighten(light, lightenAlpha[40]),
    defaultL20: lighten(light, lightenAlpha[20]),
    defaultL10: lighten(light, lightenAlpha[10])
  }, variations.includeDefaultTransparency && {
    defaultT70: polished_esm.curriedTransparentize(transparencyAlpha[70], base),
    defaultT20: polished_esm.curriedTransparentize(transparencyAlpha[20], base),
    defaultT10: polished_esm.curriedTransparentize(transparencyAlpha[10], base)
  });
}

exports.colorBuilder = colorBuilder;
exports.colorVariants = colorVariants;
//# sourceMappingURL=colorBuilder-8c1a81a8.js.map
